import Cookies from 'universal-cookie';
import { getParams, getAcApiUrl, getQueryUTMString, removeMarkupPurchaseCache, removeUserAllPromotionsCache, removeBatchSopOperationCache, removeVisitorShoppingCache, removeOerersLotteryCache, getPurchaseApiUrl } from '@tw/shared-ui-components/lib/utils/helper';
import * as ls from '@tw/shared-ui-components/lib/utils/loginSession';
import { getCSFrontendMsg } from '@tw/shared-ui-components/lib/utils/utility';
import { frontEndMessageCodes } from '@tw/shared-ui-components/lib/utils/Constants/Constants';
import axios from '@tw/shared-ui-components/lib/utils/axios_interceptor';
import {
  VISITORS_CART_PURCHASE_ITEM_CODE_LISTS,
  VISITORS_FORBID_PRODUCT_LABELS_ALREADY_REMOVED,
  VISITORS_FORBID_PRODUCT_SOP_ALREADY_REMOVED,
  CONSIGNEE_GUEST_FLAG,
  VISITORS_FIRST_SHOPPING,
  VISITORS_PROMOTIONAL_DETAILS,
  VISITORS_BINED_PHONE_NUMBER,
  VISITORS_CONTENT_STACK_DATA,
  VISITORS_UP_LEVEL_NUMBER
} from "@tw/shared-ui-components/lib/utils/Constants/Constants"
import { fetchUserMenuState } from '@tw/header-footer/lib/redux/reducers';
import { toastMsg } from '@tw/shared-ui-components/lib/components/toastMessage/toastMessage';
import base64 from 'base-64';
import utf8 from 'utf8';
// import { useDispatch } from 'react-redux';
// import { fetchLoginState } from '../../login/redux/reducers/index';
// Only SDK related will in this file. Others will in shared-ui loginSession

//=========================================================================
// CSR ONLY --------------------------------------------------------------

// const tokenExpGap = 3e5;

export const loginSession = loginInfo => {
  // available for CSR only, due to SDK required window & localStorage object
  if (typeof window !== 'undefined') {
    const cookies = new Cookies();

    //remove duplicate accessToken from visitor
    cookies.remove('accessToken');
    cookies.remove('refreshToken');
    cookies.remove('tokenExpires');
    cookies.remove('role');
    cookies.remove('loginType');
    cookies.remove('loginAdaType');

    // Original code
    /*if (!loginInfo.distributorType) {
      loginInfo.distributorType = 'FOA';
      loginInfo.usersInfo = [
        {
          name: ' ',
          amwayId: loginInfo.personalId,
          personalId: loginInfo.personalId,
        },
      ];
    }*/

    // New code
    if (loginInfo.distributorType === 'FOA' || loginInfo.usersInfo === undefined) {
      loginInfo.usersInfo = [
        {
          name: loginInfo.mainName || ' ',
          amwayId: loginInfo.personalId,
          personalId: loginInfo.personalId,
        },
      ];
    }

    // AmwayId alias
    if (loginInfo.usersInfo.length > 0) {
      for (let i = 0; i < loginInfo.usersInfo.length; i++) {
        loginInfo.usersInfo[i].amwayId = loginInfo.usersInfo[i]?.personalId || '';
      }
    }

    // general login data
    if (loginInfo.accessToken && loginInfo.refreshToken) {
      //SSO Login, build token obj to match login obj structure
      loginInfo.token = {
        accessToken: loginInfo.accessToken,
        refreshToken: loginInfo.refreshToken
      }
    }
    let exp = new Date().getTime() + ls.getLoginMaxIdle() * 60 * 1000;
    cookies.set('ada', loginInfo.ada || '', ls.cookieOption(exp));
    cookies.set('role', loginInfo.distributorType || '', ls.cookieOption(exp));
    cookies.set('accessToken', loginInfo.token.accessToken || '', ls.cookieOption(exp));
    cookies.set('isGuest', loginInfo.isGuest || false, ls.cookieOption(exp));
    cookies.set('user', loginInfo || false, ls.cookieOption(exp));
    cookies.set(
      'user',
      JSON.stringify(loginInfo.usersInfo) || JSON.stringify({}),
      ls.cookieOption(exp)
    );
    cookies.set(
      'mainName',
      loginInfo.mainName || loginInfo.usersInfo[0].name || '',
      ls.cookieOption(exp)
    );
    cookies.set('loginType', loginInfo.loginType || '', ls.cookieOption(exp));
    cookies.set(
      'loginMemberType',
      loginInfo.loginMemberType || '',
      ls.cookieOption(exp)
    );

    loginInfo.role = loginInfo.distributorType;
    localStorage.setItem('lastPageAction', new Date().getTime());

    // additional info
    if (localStorage.getItem('==ZXhwaXJlVGltZQ==') === null) {
      localStorage.setItem('=bGNfYWNjZXNzVG9rZW4=', loginInfo.token.accessToken);

      let r = JSON.parse(window.atob(loginInfo.token.accessToken.split('.')[1])).ed,
        i = new Date().getTime() + 1e3 * r;
      localStorage.setItem('==ZXhwaXJlVGltZQ==', i);

      localStorage.setItem('bGNfcmVmcmVzaFRva2Vu', loginInfo.token.refreshToken);
    }

    // Set default data
    ls.setOnbehalf({
      ada: loginInfo.ada,
      role: loginInfo.role,
      name: loginInfo.mainName || loginInfo.usersInfo[0].name,
      loginType: loginInfo.loginType || '',
      loginMemberType: loginInfo.loginMemberType || '',
    });

    // remove menu to fetch user's menu
    localStorage.removeItem('menuList');
    localStorage.removeItem('sopDetail');
    localStorage.removeItem('corpFlag');
    localStorage.removeItem('sharebarTNC');
    localStorage.removeItem('sharebarTNCAgreed');
    localStorage.removeItem('chatbot');
    localStorage.removeItem('sopAutoCombineFlag');
    //  清除加价购缓存
    removeMarkupPurchaseCache()
    //  清除批量SOP操作缓存
    removeBatchSopOperationCache()
    //  清除用户认购促销缓存
    removeUserAllPromotionsCache()
    //  清除訪客購物流程緩存
    removeVisitorShoppingCache()
    localStorage.setItem('refreshMenu', true);
  } else {
    console.log('Login session valid on browser session only');
  }
};

export const logoutSession = async router => {
  // available for CSR only, due to SDK required window & localStorage object
  if (typeof window !== 'undefined') {
    const loginSDK = await import('amway-lc-fn');
    const cookies = new Cookies();
    console.log('Remove cookies');
    // reset general login data
    cookies.set('ada', '', ls.cookieOption(-1));
    // cookies.set('vAda', '', ls.cookieOption(-1));
    cookies.set('role', 'Guest', ls.cookieOption(365));
    cookies.set('accessToken', '', ls.cookieOption(-1));
    cookies.set('refreshToken', '', ls.cookieOption(-1));
    cookies.set('tokenExpires', '', ls.cookieOption(-1));
    cookies.set('user', '', ls.cookieOption(-1));
    cookies.set('loginType', '', ls.cookieOption(-1));
    cookies.set('loginMemberType', '', ls.cookieOption(-1));

    //cookies.set("onbehalf", "", cookieOption(-1))

    loginSDK.util.removeTokens();
    localStorage.removeItem('lastPageAction');
    localStorage.removeItem('==ZXhwaXJlVGltZQ==');
    localStorage.removeItem('menuList');
    localStorage.removeItem('nav');
    localStorage.removeItem('navFooter');
    localStorage.removeItem('sopDetail');
    localStorage.removeItem('onbehalf');
    localStorage.removeItem('corpFlag');
    localStorage.removeItem('sharebarTNC');
    localStorage.removeItem('sharebarTNCAgreed');
    localStorage.removeItem('switchRecipient_regPurchasers');
    localStorage.removeItem('switch_address');
    localStorage.removeItem('chatbot');
    localStorage.removeItem('sopModify');
    localStorage.removeItem('sopCombine');
    localStorage.removeItem('sopAutoCombineFlag');
    //localStorage.removeItem("sopNavigate")

    localStorage.removeItem('depreciated');
    //  清除加价购缓存
    removeMarkupPurchaseCache()
    //  清除批量SOP操作缓存
    removeBatchSopOperationCache()
    //  清除用户认购促销缓存
    removeUserAllPromotionsCache()
    //  清除訂單抽獎緩存
    removeOerersLotteryCache()
    //  清除訪客購物流程緩存
    removeVisitorShoppingCache()
    if (router) {
      router.push('/login');
    }
  } else {
    console.log('Logout session valid on browser session only');
  }
};
//  TEP-16712 清除登录状态
export const removeLoginStatus = async (router, dispatch) => {
  try {
    if (typeof window !== 'undefined') {
      // const loginSDK = await import('amway-lc-fn');
      const cookies = new Cookies();
      console.log('Remove cookies');
      // reset general login data
      cookies.set('ada', '', ls.cookieOption(-1));
      cookies.set('vAda', '', ls.cookieOption(-1));
      cookies.set('role', 'Guest', ls.cookieOption(365));
      cookies.set('accessToken', '', ls.cookieOption(-1));
      cookies.set('refreshToken', '', ls.cookieOption(-1));
      cookies.set('tokenExpires', '', ls.cookieOption(-1));
      cookies.set('user', '', ls.cookieOption(-1));
      cookies.set('loginType', '', ls.cookieOption(-1));
      cookies.set('loginMemberType', '', ls.cookieOption(-1));

      localStorage.removeItem('lastPageAction');
      localStorage.removeItem('==ZXhwaXJlVGltZQ==');
      localStorage.removeItem('sopDetail');
      localStorage.removeItem('onbehalf');
      localStorage.removeItem('corpFlag');
      localStorage.removeItem('sharebarTNC');
      localStorage.removeItem('sharebarTNCAgreed');
      localStorage.removeItem('switchRecipient_regPurchasers');
      localStorage.removeItem('switch_address');
      localStorage.removeItem('sopModify');
      localStorage.removeItem('sopCombine');
      localStorage.removeItem('sopAutoCombineFlag');
      localStorage.removeItem('menuList');
      //localStorage.removeItem("sopNavigate")

      localStorage.removeItem('depreciated');
      //  清除加价购缓存
      removeMarkupPurchaseCache()
      //  清除批量SOP操作缓存
      removeBatchSopOperationCache()
      //  清除用户认购促销缓存
      removeUserAllPromotionsCache()
      //  清除訂單抽獎緩存
      removeOerersLotteryCache()
      //  清除訪客購物流程緩存
      removeVisitorShoppingCache()

      dispatch(fetchUserMenuState('Guest'));
      if (router) {
        router.replace('/removeCartLanding');
      }
    } else {
      console.log('removeLoginStatus >> window >> undefined');
    }
  } catch (error) {
    console.log('removeLoginStatus >> catch:', error);
  }
}
export const processLogin = async (
  res,
  info,
  nextURL,
  breakpoint = '',
  checkRenew = false,
  setShowRenew = () => { },
  router
) => {
  // CSR only
  let proceedToLanding = true;
  if (typeof window !== 'undefined') {
    // attach new info
    res.loginType = info?.businessNature1 || '';
    res.loginMemberType = info?.businessNature3 || '';
    res.mainName = info.applicant?.localName1 || '';
    res.isGuest = info.isGuest;
    res.upLevelNumber = info?.upLevelNumber ?? null;
    res.bindPhones = info?.bindPhones ?? [];
    // change of type request - Ceci @ 2022-03-07 Wechat - Get from UC
    if (res.loginMemberType) {
      res.originalDistributorType = res?.distributorType;
      res.distributorType = res.loginMemberType;
      res.role = res.loginMemberType;
    }

    if (!res.distributorType) res.distributorType = 'FOA';

    loginSession(res);

    if (
      (breakpoint === 'xs' || breakpoint === 'ms') &&
      document.querySelector('.layout__container')
    ) {
      document.querySelector('.layout__container').style.overflowY = 'auto';
      document.body.style.overflowY = 'auto';
    }

    if (checkRenew) {
      let notiType = info.expiredNotification;
      console.log('EXP', notiType);

      // no action for options: 0, 2
      let showName = res?.usersInfo[0]?.name || '';
      if ([1, 3, 4].includes(notiType.option)) {
        // before expired & grace period
        // 1 - before 2 mths - for every 7 days
        // 3 - before 1 day
        // 4 - within grace period
        let showRenew = true;
        if (notiType.option === 1) {
          // before expired 2 mths
          const today = new Date(); //'2022-05-30'
          let lastNotiObj = JSON.parse(localStorage.getItem('memberExpNotification')) || {};
          const lastNotification = new Date(lastNotiObj[info.aboNumber] || '1900-01-01');
          const notiDiffTime = Math.abs(lastNotification - today);
          const notiDiffDays = Math.ceil(notiDiffTime / (1000 * 3600 * 24));

          if (notiDiffDays > 7) {
            // every 7 days
            lastNotiObj[info.aboNumber] = today.toISOString();
            localStorage.setItem('memberExpNotification', JSON.stringify(lastNotiObj));
          } else {
            showRenew = false;
            notiType.toLanding = true;
          }
        }

        if (showRenew)
          setShowRenew({
            status: true,
            name: showName,
            date: notiType.date,
            isExpired: notiType.isExpired,
            ...notiType
          });
      } else if (notiType.option === 5) {
        // after grace period, edit SDK message
        if (document.querySelector('.login-error-text')) {
          document.querySelector('.login-error-text').classList.remove('hide');
          document.querySelector('.login-error-text').classList.add('show');
          document.querySelector('.login-error-text > div').innerHTML =
            '您的直銷商/會員資格已過期，請聯絡您的推薦人';
          logoutSession();
        }
      }
      proceedToLanding = notiType.toLanding;
    }
    //  查詢用戶是否授權個資告知
    await queryUserMemberPolicy(res)
    //  TEP-16571 訪客購物 獲取訪客落地頁面需要的頁面信息
    await visitorPurchaseRestrictionInfo(res)
    //  獲取自動合併標示
    await getSOPAutoCombineFlag();
    //  合併購物車
    await mergeCart(res); //info - memberInfo

    await fromTheDirectedPage(res, proceedToLanding, nextURL, router)

  }

  return proceedToLanding;
};
const fromTheDirectedPage = async (res, proceedToLanding, nextURL, router) => {
  try {
    let param = getQueryUTMString('?');
    if (typeof window !== 'undefined' && proceedToLanding) {
      if (nextURL === '') {
        location.href = '/landing';
      }
      const conditionalEnumeration = nextURL.indexOf("utm_source") == -1 && nextURL.indexOf("utm_medium") == -1 && nextURL.indexOf("utm_campaign") == -1 && nextURL.indexOf("utm_term") == -1;
      /**
       * 當用戶在登錄頁面點擊購物車按鈕時。
       * 此時需要判斷當前路徑參數是否轉碼。
       * 如果路徑轉碼，需要主動解碼。
       * 避免影響 UTM 參數在路徑跳轉中丟失
       * */
      if (nextURL.indexOf("h=") != -1 && conditionalEnumeration) {
        if (router) {
          router.replace(`${nextURL.indexOf("/#/") != -1 ? nextURL.substring(2) : nextURL}`)
        } else {
          location.href = `${nextURL.indexOf("/#/") != -1 ? nextURL.substring(2) : nextURL}`;
        }
      } else {
        if (router) {
          if (res?.loginMemberType == "FOA") {
            const URL_PARAMS = getFoaUrlParams(router);
            location.href = URL_PARAMS
          } else {
            const URL_PARAMS = getUrlParams(router);
            location.href = `${nextURL}${URL_PARAMS}`
          }
        } else {
          location.href = `${nextURL}${param}}`;
        }
      }
    }
  } catch (error) {
    console.log('fromTheDirectedPage >> catch:', error);
  }
}
const getUrlParams = (router) => {
  let UTM_PARAM = getQueryUTMString('?');
  return router?.asPath?.split('cart&')[1] ? `?${router.asPath.split('cart&')[1]}` : UTM_PARAM;
}
//  FOA 身份从定向 /landing 页面并追加 callback 页面以及路径参数
const getFoaUrlParams = (router) => {
  try {
    if (router?.asPath) {
      let UTM_PARAM = getQueryUTMString('?');
      let str = router?.asPath;
      if (str.indexOf('?h=') > -1) {
        let param = str.split('h=')[1] ? str.split('h=')[1] : UTM_PARAM;
        // 判断callback路径是否是 /cart 页面
        if (param.indexOf('/cart&') > -1 && param.indexOf('/cart&') == 0) {
          // 如果callback页面時 /cart 页面替换 & 符号
          return `/landing?h=${btoa(param.replace('/cart&', '/cart?'))}`
        } else if (param == "L2xhbmRpbmc=" && atob(param) == "/landing") {
          //  如果是點擊退出頁面時 返回 /landing 頁面路徑
          return `/landing`
        } else {
          return `/landing?h=${btoa(param)}`
        }
      } else {
        return `/landing`
      }
    } else {
      return `/landing`
    }
  } catch (error) {
    console.log('getFoaUrlParams >> catch:', error);
  }
}
//  查詢用戶是否授權個資告知
export const queryUserMemberPolicy = async (body) => {
  if (typeof window !== 'undefined' && typeof window !== undefined) {
    try {
      const cookies = new Cookies();
      const loginMemberType = cookies.get('loginMemberType') ?? null;
      const headers = {
        Authorization: 'Bearer ' + (body.token ? body?.token?.accessToken : body?.accessToken),
      };

      if (loginMemberType && loginMemberType == "FOA") {
        const policyType = body?.isGuest ? ['LOGIN_GUEST_DATA_NOTIFICATION'] : ['LOGIN_PERSONAL_DATA_NOTIFICATION']
        await axios
          .post(
            getAcApiUrl() + '/queryUserMemberPolicy',
            {
              loginAda: body?.ada,
              policyType
            },
            {
              headers: headers,
            }
          )
          .then((res) => {
            if (!res?.data?.success) {
              console.log('query User Member Policy: ' + JSON.stringify(res.data));
              toastMsg(res.data.message);
            } else if (res.data.code == '0' && res.data.success) {
              //  LC登錄組件 是否彈出過個資告知彈出窗 標識
              let contentStackData = []
              const memberPolicy = res?.data?.data ?? [];
              if (memberPolicy.length > 0) {
                memberPolicy.map((item) => {
                  if (item?.data && item?.data?.length > 0) {
                    const AGREE_N_LIST = item?.data?.filter((item) => item.agree == "N")
                    if (AGREE_N_LIST.length > 0) {
                      contentStackData.push(item)
                    }
                  } else {
                    contentStackData.push(item)
                  }
                })
              }
              localStorage.setItem(VISITORS_CONTENT_STACK_DATA, contentStackData.length == 0);
            }
          })
          .catch((error) => {
            console.log('queryUserMemberPolicy >> error:', error);
          })
      }
    } catch (error) {
      console.log('queryUserMemberPolicy >> catch:', error);
    }
  }
}
export const mergeCart = async login => {
  // CRS only
  if (typeof window !== 'undefined' && typeof window !== undefined) {
    const headers = {
      Authorization: 'Bearer ' + (login.token ? login.token.accessToken : login.accessToken),
    };
    console.log('MergeCart - Calling');
    const cookies = new Cookies();
    const loginMemberType = cookies.get('loginMemberType') ?? null;
    const vAda = cookies.get('vAda') ?? ''
    try {
      if ((loginMemberType && loginMemberType == "FOA") || cookies.get('vAda')) {
        await axios
          .post(
            getAcApiUrl() + '/orders/mergeCart',
            {
              ada: login.ada,
              adaV: vAda,
              orderType: 'INT',
              //cartId: 0
            },
            {
              headers: headers,
            }
          )
          .then(res => {
            console.log('MergeCart Called', res);
            cookies.remove('vAda');
            if (!res.data.success) {
              console.log('Merge cart failed: ' + JSON.stringify(res.data));
              const WITHOUT_PROMPTING_ERROR_CODE = [
                'OM.B.CART_NOT_EXIST.01',
                'OM.B.CART_PRODUCTS_NOT_EXIST.01',
                'OM.B.PARAM_VALIDATE_ERROR.01',
                'OM.B.MARKET_CENTER_FREE_DELIVERY_INTERFACE_DATA_EXCEPTION.01',
                'OM.B.ADD_CART_CONSIGNEE_BUYER_ERROR.01',
                'OM.P.PRODUCT_PRICE_NUMBER_ERROR.01',
                'OM.B.PARAM_INVALID.01',
                'OM.B.RENEW_PRODUCT_VERIFY_ERROR.01'
              ]
              if (!WITHOUT_PROMPTING_ERROR_CODE.includes(res.data.code)) {
                toastMsg(res.data.message);
              }
            } else if (res.data.code == '0' && res.data.success) {
              {/* TEP-16571 訪客購物 start */ }
              const shoppingCarts = res?.data?.data?.shoppingCarts ?? [];
              //  是否访客的标记 交易中心根据用户中心的结果判断，foa+无上级+foaRole='guest'
              const consigneeGuestFlag = shoppingCarts?.consigneeGuestFlag ?? false;
              if (consigneeGuestFlag) {
                localStorage.setItem(CONSIGNEE_GUEST_FLAG, consigneeGuestFlag)
              }
              //  sop商品标记：cartTips[i]type.code=OM.B.FORBID_REPURCHASE_PRODUCT_LABELS_ALREADY_REMOVED_SOP.01
              const isCartSOP = shoppingCarts.map(cart =>
                cart?.cartTips ? cart.cartTips.filter(item => item?.type == 'OM.B.FORBID_REPURCHASE_PRODUCT_LABELS_ALREADY_REMOVED_SOP.01') : []
              ).flat();
              //  是否有sop商品
              if (isCartSOP && isCartSOP.length > 0 && JSON.stringify(isCartSOP) !== "[undefined]") {
                localStorage.setItem(VISITORS_FORBID_PRODUCT_SOP_ALREADY_REMOVED, JSON.stringify(isCartSOP))
              }
              //  使用双重 map 方法提取所有购物车的 itemCode
              const itemCodes = shoppingCarts.map(cart =>
                cart?.shoppingCartItems && cart?.shoppingCartItems.length > 0 ? cart?.shoppingCartItems?.map(item => ({ itemCode: item?.product?.itemCode })) : []
              ).flat();
              if (itemCodes.length > 0) {
                localStorage.setItem(VISITORS_CART_PURCHASE_ITEM_CODE_LISTS, JSON.stringify(itemCodes))
              }
              {/* TEP-16571 訪客購物 End */ }
            }
          });
      }
    } catch (e) {
      console.log('Merge Cart Catch', e);
      cookies.remove('vAda');
    }
  }
};
//  TEP-16571 訪客購物 獲取訪客落地頁面需要的頁面信息
export const visitorPurchaseRestrictionInfo = async (body) => {
  console.log('=========visitorPurchaseRestrictionInfo');
  try {
    /**
     * 這段代碼的作用主要是用於獲取支撐 訪客限購落地頁面數據
     * 1、用戶類型 FOA
     * 2、用戶為 FOA 訪客
     * 3、用戶有購貨紀錄
    */
    if (typeof window !== 'undefined' && typeof window !== undefined) {
      const headers = {
        Authorization: 'Bearer ' + (body.token ? body.token.accessToken : body.accessToken),
      };
      const loginMemberType = body?.loginMemberType ?? "FOA"
      //  是否是第一次購貨
      const firstShopping = body?.firstShopping ?? false;
      localStorage.setItem(VISITORS_FIRST_SHOPPING, firstShopping)
      //  是否是FOA訪客
      const isFoaVisitor = body?.isFoaVisitor ?? false;
      //  登錄 FOA 手機號碼
      const loginUserPhone = body?.bindPhones.filter(phone => phone?.type === 'M')?.[0]?.combinedPhoneNumber ?? null;
      //  判斷 是否為FOA訪客 同時判斷 手機號碼是否存在 （這裡的手機號碼分享ada 給直銷商彈窗 UI 有用到）
      if ((isFoaVisitor == true || isFoaVisitor == "true") && loginUserPhone) {
        localStorage.setItem(VISITORS_FORBID_PRODUCT_LABELS_ALREADY_REMOVED, isFoaVisitor)
        localStorage.setItem(VISITORS_BINED_PHONE_NUMBER, loginUserPhone)
      }
      // 访客上级手机号码
      if ((isFoaVisitor == true || isFoaVisitor == "true") && body?.upLevelNumber) {
        localStorage.setItem(VISITORS_UP_LEVEL_NUMBER, body?.upLevelNumber)
      }
      //  是 FOA && 是 FOA 訪客 && 有上线直销商 && 不是第一次購貨
      if (
        loginMemberType == "FOA" &&
        (isFoaVisitor == true || isFoaVisitor == "true") &&
        body?.upLevelNumber &&
        (firstShopping == false || firstShopping == 'false')
      ) {
        await axios
          .post(
            getAcApiUrl() + '/visitorPurchaseLimitLandingPageInfo',
            {
              loginAda: body?.ada,
              upLevelNumber: body?.upLevelNumber,
              loginMemberType,
              firstShopping,
              isFoaVisitor,
            },
            {
              headers: headers,
            }
          )
          .then(res => {
            if (res?.status == 200 && res?.data) {
              {/* TEP-16571 訪客購物 獲取訪客落地頁面需要的頁面信息 start */ }
              // 訪客限购促销超链接数据
              const promotionalLink = res?.data?.promotionalLink ?? null;
              //  訪客限购上級直銷商數據
              const UP_LEVEL_INFO = res?.data?.upLevelData ?? null;
              //  登錄用戶綁定的手機信息
              const LOGIN_USER_DATA = res?.data?.loginUserData ?? null;
              const loginUserPhones = LOGIN_USER_DATA?.data[0]?.details[0]?.bindPhones ?? [];
              if (promotionalLink && UP_LEVEL_INFO) {
                let upLevelList = []
                const { applicant, bindPhones } = UP_LEVEL_INFO?.data[0]?.details[0];
                if (bindPhones && bindPhones?.length > 0) {
                  bindPhones.map((item) =>
                    upLevelList.push(
                      {
                        ...item,
                        localName: applicant?.localName1 ?? applicant?.localName2,
                        englishName: applicant?.englishName1 ?? applicant?.englishName2
                      }
                    ))
                }
                const CacheData = {
                  promotionalLink,
                  upLevelList,
                  loginUserPhones
                }
                localStorage.setItem(VISITORS_PROMOTIONAL_DETAILS, JSON.stringify(CacheData))
              }
              {/* TEP-16571 訪客購物 獲取訪客落地頁面需要的頁面信息 End */ }
            }
          });
      }
    }


  } catch (error) {
    console.log('visitorPurchaseRestrictionInfo >> catch:', error);
  }
}
const getSOPAutoCombineFlag = async () => {
  if (typeof window !== 'undefined') {
    try {
      /**
       *    2024/2/10 @Xuan Lu @Todd
       *    由於 Content Stack 請求超時導致的開啟開關後還會有用戶通過手動方式合併訂單
       *    於 Todd 確認後將緩存在瀏覽器緩存中的屬性默認設置為true
      */
      localStorage.setItem('sopAutoCombineFlag', true)
      // await axios.post(getAcApiUrl() + '/anon/sopmodify/getAutoCombineFlag')
      //   .then(res => {
      //     localStorage.setItem('sopAutoCombineFlag', res.data)
      //   });
    } catch (e) {
      console.log('Failed to get SOP Combine Flag:' + e)
    }
  }
}

export const mustLogin = ctx => {
  // call from master-nextjs only
  if (typeof window === 'undefined') {
    // get current path
    let path = ctx?.req?.url || '';
    //console.log("MUSTLOGIN", path)

    // this code is for if use this in nextjs project
    //let currentPath = path ? path.split("?")[0] : "";
    //if (path.length > 0 && requiredLogin.includes(currentPath)) {

    const c = new Cookies(ctx?.req?.headers?.cookie);
    if (!c.accessToken) {
      // ctx.res.writeHead(303, { Location: '/landing?exp=m&h=' + encodeURIComponent(path) });
      let bytes = utf8.encode(path);
      let url = base64.encode(bytes);
      ctx.res.writeHead(303, { Location: '/landing?exp=m&h=' + url });
      ctx.res.end();
      return false;
    }
  }
  return true;
};

// Refresh Token Handling : Start -----------------------------------
export const toLogout = (reason = '') => {
  // work for NextJS - CSR only
  let forceRedirect = false;
  let path = window.location.pathname;
  if (window.refreshTokenProtectedList.length > 0) {
    forceRedirect = window.refreshTokenProtectedList.some(route => path.match(route));
  } else {
    if (window.location.pathname !== '/login') forceRedirect = true;
  }

  logoutSession();

  if (forceRedirect) {
    // enhancement for return back to previous page
    window.location.href =
      // '/login?exp=' + reason + '&h=' + window.location.pathname + (window.location.search || '');
      '/login?exp=' +
      reason +
      '&h=' +
      btoa(window.location.pathname + (window.location.search || ''));
  }
};

export const initRefreshToken = async (protectedList = []) => {
  // to start localStorage listener
  window.lcCatchTokenScheduler = setTimeout(() => {
    catchAndUpdateToken();
  }, 1000);

  // to register LC SDK to window
  if (typeof window.lcSDK === 'undefined') {
    window.lcSDK = await import('amway-lc-fn');
    window.lcSDK.api.setLcEnvironment(ls.getLoginSDKEnv());
  }

  // to register current expValue
  if (typeof window.lcExp === 'undefined') {
    window.lcExp = localStorage.getItem('==ZXhwaXJlVGltZQ==') || 0;
  }

  // to avoid concurrent execution
  if (typeof window.refreshTokenFlag === 'undefined') {
    window.refreshTokenFlag = false;
  }

  // to avoid too frequent execution
  if (typeof window.refreshTokenLast === 'undefined') {
    window.refreshTokenLast = new Date().getTime();
  }

  // to remember protected list
  if (
    typeof window.refreshTokenProtectedList === 'undefined' ||
    window.refreshTokenProtectedList.length === 0
  ) {
    if (protectedList.length > 0) window.refreshTokenProtectedList = protectedList;
    else window.refreshTokenProtectedList = [];
  }

  // refresh token scheduler
  if (typeof window.refreshTokenScheduler === 'undefined') {
    window.refreshTokenScheduler = 0;
  }
};
export const scheduleNextCheck = () => {
  // CSR only

  // Decide when to refresh token again
  // 3 mins before actual expired
  const newExp = parseInt(localStorage.getItem('==ZXhwaXJlVGltZQ==') || 0);
  if (newExp > 0) {
    const tokenExp = newExp - new Date().getTime() - 3 * 60 * 1000; // time based on token, 3 mins before expired

    let nextRun = 0;
    const lastPageAction = parseInt(localStorage.getItem('lastPageAction') || new Date().getTime());
    const maxIdle = (ls.getLoginMaxIdle() - 3) * 60 * 1000 - (new Date().getTime() - lastPageAction); // last action time
    // - 3 for buffer 3 mins

    // when is the last? last check is to check lastAction to logout
    if (maxIdle < 0)
      nextRun = ls.getLoginMaxIdle() * 60 * 1000 - (new Date().getTime() - lastPageAction);
    else nextRun = tokenExp;

    // console.log(
    //   'Token scheduler',
    //   'token',
    //   tokenExp / 60 / 1000,
    //   'idle',
    //   maxIdle / 60 / 1000,
    //   'next',
    //   nextRun / 60 / 1000
    // );
    if (nextRun > 0) {
      // if idle - token exp > 120 mins, then set next refresh
      window.refreshTokenScheduler = setTimeout(() => {
        checkAndRefreshToken([], false); // false => do not update lastPageAction
      }, nextRun);
    } else {
      // if idle - token exp < 120 mins, then cancel timeout (2 hour)
      clearTimeout(window.refreshTokenScheduler);
      window.refreshTokenScheduler = 0;
    }
  }
};

export const catchAndUpdateToken = () => {
  if (typeof window !== 'undefined') {
    window.lcCatchTokenScheduler = setTimeout(() => catchAndUpdateToken(), 1000);

    const cacheExp = parseInt(window.lcExp || 0);
    const newExp = parseInt(localStorage.getItem('==ZXhwaXJlVGltZQ==') || 0);
    if (cacheExp !== newExp) {
      const aToken = localStorage.getItem('=bGNfYWNjZXNzVG9rZW4=') || '';
      const rToken = localStorage.getItem('bGNfcmVmcmVzaFRva2Vu') || '';
      const expToken = localStorage.getItem('==ZXhwaXJlVGltZQ==') || 0;

      // Update to cache
      window.lcExp = localStorage.getItem('==ZXhwaXJlVGltZQ==');

      console.log('Refresh token - new token', aToken);

      if (aToken) {
        const cookies = new Cookies();
        let exp = new Date().getTime() + ls.getLoginMaxIdle() * 60 * 1000;
        cookies.set('ada', ls.getADA() || '', ls.cookieOption(exp));
        cookies.set('accessToken', aToken || '', ls.cookieOption(exp));
        cookies.set('refreshToken', rToken || '', ls.cookieOption(ls.loginCookieExp()));
        cookies.set('tokenExpires', expToken || '', ls.cookieOption(ls.loginCookieExp()));

        cookies.set('isGuest', cookies.get('isGuest') || false, ls.cookieOption(exp));
        cookies.set('role', ls.getRole() || '', ls.cookieOption(exp));
        cookies.set('user', ls.getUsers().usersInfo || JSON.stringify({}), ls.cookieOption(exp));
        cookies.set('mainName', ls.getUsers().mainName || ls.getUsers().usersInfo[0]?.name || '', ls.cookieOption(exp));
        cookies.set('loginType', ls.getUsers().loginType || '', ls.cookieOption(exp));
        cookies.set('loginMemberType', ls.getUsers().loginMemberType || '', ls.cookieOption(exp));

        // Update AXIOS/process
        process.loggedInUserInfo = {
          accessToken: aToken,
          ada: ls.getADA(),
          role: cookies.get('role'),
          loginType: cookies.get('loginType'),
        };

        closeSDKLoadingIco();

        scheduleNextCheck();
      } else if (
        window.location.pathname.toLowerCase() !== '/login' &&
        window.location.pathname.toLowerCase() !== '/linecallback'
      ) {
        // no token, then force to logout & clear all
        logoutSession();
      }
    }
    // no action for same exp
    if (window.refreshTokenScheduler === 0) scheduleNextCheck();
  }
};

export const isIdleMax = () => {
  let lastPageAction = localStorage.getItem('lastPageAction') || new Date().getTime();
  return new Date().getTime() - parseInt(lastPageAction) > ls.getLoginMaxIdle() * 60 * 1000;
};

export const allowRefreshToken = () =>
  !window.refreshTokenFlag && new Date().getTime() - window.refreshTokenLast > 60 * 1000;

export const checkAndRefreshToken = async (
  protectedList = [],
  updateAction = true /*test = ''*/
) => {
  // available for CSR only, due to SDK required window & localStorage object
  if (typeof window !== 'undefined') {
    await initRefreshToken(protectedList);
    let logs = [new Date()]; // reduce console log

    // if not pass in, then check in window object for cache data
    if (protectedList.length === 0 && window.refreshTokenProtectedList.length > 0) {
      protectedList = window.refreshTokenProtectedList;
    }

    // Get mandatory cookie data
    const cookies = new Cookies();
    let ada = cookies.get('ada');
    let curToken = cookies.get('accessToken');

    // When ada and aToken exists, then need to validate on the token validity,
    // exclude login screen
    if (
      ada &&
      curToken &&
      window.location.pathname.toLowerCase() !== '/login' &&
      window.location.pathname.toLowerCase() !== '/linecallback'
    ) {
      const loginSDK = window.lcSDK;
      const isExpired = loginSDK.util.isTokenExpired();

      /* 06/07/2022 - LC request to remove forced log out */
      const isIdleReached = isIdleMax();
      if (updateAction) {
        localStorage.setItem('lastPageAction', new Date().getTime());
      }

      /* 06/07/2022 - LC request to remove forced log out */
      // Cross check on page last action, if > 2 hour idle, then force expire
      if (isIdleReached) {
        // force logout after 2 hour
        logs.push('Idle 2 hour, force logout');
        console.log('RefreshToken', logs);
        toLogout('t');
      } else if (isExpired) {
        // if less than 1 hour, try to refresh
        const allowRefresh = allowRefreshToken();

        logs.push(
          'expired-lastCheck ' +
          new Date(window.refreshTokenLast).toString() +
          '; refresh-now? ' +
          allowRefresh
        );

        if (allowRefresh) {
          // to avoid multiple calls at the same time
          window.refreshTokenFlag == true;
          window.refreshTokenLast = new Date().getTime();

          loginSDK.util.refreshAccessToken(res => {
            if (!res.success) {
              // Error from SDK, if refresh token is expired, action: to logout

              if (
                protectedList.length > 0 &&
                protectedList.some(route => window.location.pathname.match(route))
              ) {
                if (localStorage.getItem('debug')) {
                  // for debugging purpose
                  alert('sdk.refreshAccessToken: ' + JSON.stringify(res));
                  alert(res?.message);
                }
              }

              logs.push('api error or expired', res);

              try {
                // Log to bff
                axios.post(getAcApiUrl() + '/anon/eventLog', {
                  type: 'error',
                  message: `Refresh token - SDK.RefreshTokenError ${JSON.stringify(res)}`,
                });
              } catch (e) {
                logs.push('log error');
              }

              window.refreshTokenFlag = false;
              console.log('RefreshToken', logs);
              toLogout('r');
            }

            closeSDKLoadingIco();
          });

          // update token to cookies
          // let catchAndUpdateToken to handle it in storage listerner
          // this will handle to update the tokens into cookie

          setTimeout(() => {
            // hava a gap between next call, at least 1 second
            window.refreshTokenFlag = false;
            window.refreshTokenLast = new Date().getTime();
            closeSDKLoadingIco();
          }, 1000);
        }
      } else {
        logs.push('Still valid');
      }
    }

    if (window.refreshTokenScheduler === 0)
      // incase scheduler missing
      scheduleNextCheck();

    if (logs.length > 1) console.log('RefreshToken', logs);
  }
  closeSDKLoadingIco();
};

export const closeSDKLoadingIco = () => {
  if (typeof window !== 'undefined') {
    try {
      if (document.querySelector('#loadingToast')) document.querySelector('#loadingToast').remove();
    } catch (e) {
      console.log('nothing');
    }
  }
};

// Refresh Token Handling : End -----------------------------------

export const ssoLogin = async (ssoToken) => {
  if (typeof window !== 'undefined') {
    // CSR only
    const param = getParams();
    console.log(param);
    if ((ssoToken || param.ssoToken) && sessionStorage.getItem("ssoChecking") == undefined) {
      let sessionToken = 'ssoToken=' + (ssoToken ?? param.ssoToken);
      sessionStorage.setItem("ssoChecking", true);
      // to register LC SDK to window
      if (typeof window.lcSDK === 'undefined') {
        window.lcSDK = await import('amway-lc-fn');
        window.lcSDK.api.setLcEnvironment(ls.getLoginSDKEnv());
      }
      const loginSDK = window.lcSDK;
      // get AppToken
      let appToken;
      let tokenURL = getAcApiUrl() + '/anon/lc/getLoginToken';
      if (window.location.hostname === 'localhost' || window.location.hostname === '172.0.0.1')
        tokenURL = 'https://api-qa.amwaynet.com.tw/bff/ci/anon/lc/getLoginToken';
      let TOKEN = await axios.post(tokenURL)
      if (TOKEN.data?.data === null) {
        appToken = 'INVALID TOKEN';
      } else {
        if (TOKEN.data.code === 'ACCESS_DENIED' || TOKEN.data.level === 'error')
          alert(TOKEN.data.message);
        else {
          appToken = TOKEN.data;
        }
      }
      const ssoObj = {
        sessionToken: ssoToken ?? param.ssoToken,
        appToken: appToken,
        replace: true
      };
      try {
        const ssoRes = await loginSDK.util.ssoLogin(ssoObj)
        sessionStorage.removeItem("ssoChecking");
        console.log('SSO', ssoRes);

        if (ssoRes.ada && ssoRes.accessToken && ssoRes.usersInfo) {
          console.log('Session token found, logout existing session');
          // additional info
          localStorage.setItem('=bGNfYWNjZXNzVG9rZW4=', ssoRes.accessToken);
          localStorage.setItem('==ZXhwaXJlVGltZQ==', ssoRes.expireTime);
          localStorage.setItem('bGNfcmVmcmVzaFRva2Vu', ssoRes.refreshToken);
          const headers = {
            Authorization: 'Bearer ' + ssoRes.accessToken,
          };
          console.log('SSO-header', headers, {
            personalId: ssoRes.usersInfo[0].personalId,
            aboNumber: ssoRes.ada,
            loginInfo: true,
          });
          const memberInfo = await axios
            .post(
              getAcApiUrl() + '/profile',
              {
                personalId: ssoRes.usersInfo[0].personalId,
                loginAda: ssoRes.ada,
                loginInfo: true,
              },
              {
                headers: headers,
              }
            )
          console.log('Profile', memberInfo);
          //registerTraceId(memberInfo)
          let nextURL = '';
          if (ssoRes.accessToken) {
            if (
              (location.hostname === 'localhost' || location.hostname === '127.0.0.1') &&
              location.hash
            ) {
              let goto = location.hash.replace(sessionToken, '');
              console.log(goto);
              goto = goto.substr(1, goto.length - 1);
              //console.log(goto)
              nextURL = '/#/landing?h=' + btoa(goto);
            } else {
              //if come from login page
              if (location.pathname === '/login') {
                //search: "?h=L3Byb2ZpbGUvY291cG9uP3Nzb1Rva2VuPTZjZTZjZDc1LTQ0MjAtNDJkMi04YmJjLTUxMTBhOTM3YWJiOCZjaGFubmVsPUJD"
                let goto = window.atob(location.search.split('h=')[1]).replace(sessionToken, '');
                nextURL = '/landing?h=' + btoa(goto);
              }
              else {
                let goto = location.pathname + location.search.replace(sessionToken, '');
                //console.log(goto)
                nextURL = '/landing?h=' + btoa(goto);
              }
            }
          }
          console.log('NextURL', nextURL);
          // login to new session
          processLogin(ssoRes, memberInfo.data, nextURL);
        }
        else {
          let nextURL = '';
          if (location.pathname === '/login') {
            //search: "?h=L3Byb2ZpbGUvY291cG9uP3Nzb1Rva2VuPTZjZTZjZDc1LTQ0MjAtNDJkMi04YmJjLTUxMTBhOTM3YWJiOCZjaGFubmVsPUJD"
            let goto = window.atob(location.search.split('h=')[1]).replace(sessionToken, '');
            nextURL = '/landing?h=' + btoa(goto);
          }
          else {
            let goto = location.pathname + location.search.replace(sessionToken, '');
            nextURL = '/landing?h=' + btoa(goto);
          }
          window.location.href = nextURL;
        }
      } catch (e) {
        sessionStorage.removeItem("ssoChecking");
        console.log('sso login failed', e);
        if (e.code === frontEndMessageCodes.LC_F_ALREADY_LOGIN) {
          //Display message if user already logged in
          const cookies = new Cookies();
          let msg = await getCSFrontendMsg(frontEndMessageCodes.LC_F_ALREADY_LOGIN);

          if (cookies.get('role') !== "FOA" && cookies.get('accessToken') && cookies.get('ada')) {
            msg.message = msg.message.replace("[ADA]", "編號 " + cookies.get('ada') + " ");
          } else {
            const res = await axios({
              headers: ls.getAccessHeader(),
              method: "post",
              url: getAcApiUrl() + '/profile',
              data: {
                personalId: ls.getPersonalId(),
                loginAda: cookies.get('ada'),
              },
            });
            msg.message = msg.message.replace("[ADA]", " " + res.data.phone + " ");
          }

          alert(msg.message);
        }

        //redirect
        let nextURL = '';
        if (location.pathname === '/login') {
          //search: "?h=L3Byb2ZpbGUvY291cG9uP3Nzb1Rva2VuPTZjZTZjZDc1LTQ0MjAtNDJkMi04YmJjLTUxMTBhOTM3YWJiOCZjaGFubmVsPUJD"
          let goto = window.atob(location.search.split('h=')[1]).replace(sessionToken, '');
          nextURL = '/landing?h=' + window.btoa(goto);
        }
        else {
          let goto = location.pathname + location.search.replace(sessionToken, '');
          nextURL = '/landing?h=' + window.btoa(goto);
        }
        window.location.href = nextURL;
      }
    }
  }
};

export const ssoRedirect = async (toURL, callBack) => {
  // CSR only
  if (typeof window !== 'undefined') {
    const res = await axios({
      headers: ls.getAccessHeader(),
      method: 'post',
      url: getAcApiUrl() + '/lc/getToken',
      data: {
        ada: ls.getADA(),
        personalId: ls.getPersonalId(),
      },
    });

    let ret = { url: '', status: true, message: '' };
    if (typeof res.data === 'string') {
      // is ? exists?
      if (toURL.includes("?")) {
        ret.url = toURL + '&ssoToken=' + res.data + '&channel=';
      } else {
        ret.url = toURL + '?ssoToken=' + res.data + '&channel=';
      }
    } else {
      ret.status = false;
      ret.message = 'Invalid session';
    }
    callBack(ret);
  }
};

export const catchRefererKey = async () => {
  if (typeof window !== 'undefined') {
    const params = getParams();
    if (params?.d) {
      // pending on decode
      const res = await axios({
        method: 'post',
        url: getAcApiUrl() + '/anon/share/decode',
        data: {
          encryptedText: params.d,
          loginAda: ls.getADA(),
          shareUrl: window.location.href
        },
      });
      if (res && res?.data && res?.data?.decoded) {
        console.log(res);
        sessionStorage.setItem('shareADA', res?.data?.decoded);
      }
    }
  }
};

//=========================================================================
// code below will move to helper/loginSession file
// CSR & SSR, SSR required ctxCookie (context.req.headers.cookie)

// alias to helper/loginSession
const depreciated_log = fn => {
  console.warn(
    'IMPORTANT: ' +
    fn +
    ' is depreciated, please import from @tw/shared-ui-components/lib/utils/loginSession'
  );
  let log = JSON.parse(localStorage.getItem('depreciated') || '{}');
  if (log && log[fn]) log[fn]++;
  else log[fn] = 1;
  localStorage.setItem('depreciated', JSON.stringify(log));
};

export const getAccessHeader = cs => {
  depreciated_log('getAccessHeader');
  return ls.getAccessHeader(cs);
};
export const getTokens = cs => {
  depreciated_log('getTokens');
  return ls.getTokens(cs);
};
export const getUsers = cs => {
  depreciated_log('getUsers');
  return ls.getUsers(cs);
};
export const getADA = cs => {
  depreciated_log('getADA');
  return ls.getADA(cs);
};
export const getRole = cs => {
  depreciated_log('getRole');
  return ls.getRole(cs);
};
export const getPersonalId = cs => {
  depreciated_log('getPersonalId');
  return ls.getPersonalId(cs);
};
export const getAll = (cs, ctx) => {
  depreciated_log('getAll');
  return ls.getAll(cs, ctx);
};
export const setOnbehalf = r => {
  depreciated_log('setOnbehalf');
  return ls.setOnbehalf(r);
};
export const getOnbehalf = () => {
  depreciated_log('getOnbehalf');
  return ls.getOnbehalf();
};



export const reportErrorMessages = (key, errorObject) => {
  try {
    console.log(`${key}:`, errorObject);
    let errorString = JSON.stringify(errorObject, Object.getOwnPropertyNames(errorObject));
    logFEError({
      key,
      ...JSON.parse(errorString)
    })
  } catch (error) {
    console.log('reportErrorMessages >> catch', error);
  }
}
/**
 * 获取访客状态。
 * 如果存在 "vAda" 的 cookie 且不存在 "ada" 的 cookie ，则返回 true ，否则返回 false 。
 * @returns {boolean} 访客状态。
 */
const getVisitorStatus = () => {
  const cookies = new Cookies();
  if (cookies.get("vAda") && !cookies.get("ada")) {
    return true;
  } else {
    return false;
  }
};
/**
 * 获取通用登录参数
 * 如果运行环境不是浏览器（如服务器端），则返回默认的空参数对象
 * 如果是浏览器环境：
 *   - 若是访客状态，返回从 cookies 中获取的 vAda 值作为 loginAda，固定的 ROLE_FOA 作为 loginMemberType，"V" 作为 loginType
 *   - 若不是访客状态，返回从 cookies 中获取的 ada 值作为 loginAda，role 值作为 loginMemberType，loginType 值作为 loginType
 * @returns {Object} 包含通用登录参数的对象
 */
const getCommonParameters = () => {
  if (typeof window === "undefined")
    return {
      loginAda: "",
      loginMemberType: "",
      loginType: "",
      bizCode: "",
      channelCode: "",
    };

  const cookies = new Cookies();
  const isVisitor = getVisitorStatus();
  const ROLE_FOA = "FOA"
  if (isVisitor) {
    return {
      loginAda: cookies.get("vAda") || "",
      loginMemberType: ROLE_FOA || "",
      loginType: "V" || "",
    };
  } else {
    return {
      loginAda: cookies.get("ada") || "",
      loginMemberType: cookies.get("role") || "",
      loginType: cookies.get("loginType") || "",
    };
  }
};

/**
 * 记录前端错误日志
 * @param {Object} [error={}] - 要记录的错误对象
 * 此函数尝试向指定的 API 端点发送错误日志。如果在发送过程中发生异常，
 * 则会在控制台打印错误信息，但不会在此处调用自身以避免无限循环。
 */
export const logFEError = (error = {}) => {
  try {
    const apiUrl = getPurchaseApiUrl();
    const baseURL = apiUrl ?? process?.env?.PURCHASE_BFF_API;
    const url = `/common/log-fe-error`;
    axios
      .post(
        `${baseURL}${url}`,
        {
          ...getCommonParameters(),
          error,
        },
      )
      .catch((error) => {
        console.error("[logFEError] >> Exception:\n", error);

        // DO NOT CALL logFEError from this place
      });
  } catch (error) {
    console.log('logFEError >> catch:', error);
  }
};


/**
 * 格式化手机号码，将输入的手机号码转换为标准格式。
 * 
 * @param {string|null|undefined} phone - 输入的手机号码，可以为字符串、null或undefined。
 * @returns {string|null|undefined} 返回格式化后的手机号码，若输入无效则返回原输入。
 * 
 * @throws {Error} 当手机号码长度不为10位时抛出错误。
 * 
 * @example
 * // 返回 '1234-567890'
 * formatMobilePhone('1234567890');
 * 
 * // 返回 null
 * formatMobilePhone(null);
 */
export const formatMobilePhone = (phone) => {
  try {
    if (phone === null || phone === undefined) return phone;
    // 移除所有非数字字符
    const cleanedPhone = phone.replace(/\D/g, '');

    // 检查电话号码长度是否为10位
    if (cleanedPhone.length !== 10) {
      throw new Error('无效的电话号码长度');
    }
    // 提取前4位和后6位数字
    const prefix = cleanedPhone.substring(0, 4);
    const suffix = cleanedPhone.substring(4);

    // 使用正则表达式在适当位置插入连字符
    const formattedPhone = `${prefix}-${suffix}`;

    return formattedPhone;
  } catch (error) {
    console.log('formatMobilePhone >> catch:', error);
    return phone;
  }
}